import { render, staticRenderFns } from "./RulesetEditor.vue?vue&type=template&id=f09ff672&scoped=true&"
import script from "./RulesetEditor.vue?vue&type=script&lang=js&"
export * from "./RulesetEditor.vue?vue&type=script&lang=js&"
import style0 from "./RulesetEditor.vue?vue&type=style&index=0&id=f09ff672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ff672",
  null
  
)

export default component.exports